angular
.module( 'ribytRsvpApp' )
.directive( 'groundByt', function ( $sessionStorage, $rootScope, $state, moment, $sce, $http, ENV ) {
    return {
        'restrict': 'E',
        'scope': {
            'currentByt': '@',
            'timezone': '@',
            'isTimeFormat24': '@'
        },
        'templateUrl': 'views/directives/itinerary/groundByt.html',
        'link': function ( scope, element, attrs ) {
            // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
            scope.trustedHtml = function ( plainText ) {
                return $sce.trustAsHtml( plainText );
            };
            scope.preview = $rootScope.preview;

            scope.isAccepted = function ( passedByt ) {
                var data = {
                    bytID: passedByt.bytID.id,
                    status: passedByt.isAccepted
                };
                $http.put( ENV.apiEndpoint + '/ribyt/rsvp/setBytStatus/' + $sessionStorage.inviteHash, data )
                    .then( function setBytStatus ( ) {
                        // update the invite session storage/scope just in case they refresh
                        var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
                        // find the byt in the invite
                        var modifiedBytIndex = _.findIndex( _.get( invitation, 'byts' ), {'bytID.id': _.get( passedByt, 'bytID.id' )} );

                        // set the isAccepted value to the invite
                        _.set( invitation, 'byts[' + modifiedBytIndex + '].isAccepted', passedByt.isAccepted );
                        // save the results in $sessionStorage
                        _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invitation ) );
                    }, function setBytStatusError ( error ) {
                    } );
            };

            var byt = JSON.parse( scope.currentByt );
            var newByt = {};

            _.each( byt, function forEachByt ( value, key ) {
                newByt[key] = value;
            } );

            scope.byt = determineOtherLocation( newByt );

            // populate datetimeStart with the byt's date time start if we don't have one on the byt level
            populateDatetimeStart( scope.byt );

            function populateDatetimeStart ( byt ) {
                if ( !_.get( byt, 'bytDetails.datetimeStart' ) ) {
                    scope.byt.bytDetails.datetimeStart = scope.byt.bytID.datetimeStart;
                }
            }

            scope.pdfView = _.get( $sessionStorage, 'pdfView', false );

            function determineOtherLocation ( byt ) {
                var locationPoints = []; // array that contains the locations that need to be modified

                // determine if this is a start or end location that needs to be modified
                // this only happens if the location start/end is equal to Other
                if ( byt.bytID.bytDetails.startLocation === 'Other' ) {
                    locationPoints.push( 'start' );
                } else {
                    _.set( byt, 'startLocation', _.get( byt, 'bytID.bytDetails.startLocation' ) );
                }

                if ( byt.bytID.bytDetails.endLocation === 'Other' ) {
                    locationPoints.push( 'end' );
                } else {
                    _.set( byt, 'endLocation', _.get( byt, 'bytID.bytDetails.endLocation' ) );
                }

                // for each start/end location that has type other, we will process the byt
                _.each( locationPoints, function forEachOtherLocations ( startOrEnd ) {
                    // get relavent byt information at the byt level
                    var startOrEndDetails = _.get( byt, 'bytID.bytDetails.' + startOrEnd + 'LocationDetails' );
                    var startOrEndLocation = _.get( byt, 'bytID.bytDetails.' + startOrEnd + 'Location' );

                    // prepare the dropofflocation that we will display

                    if ( _.get( byt, 'bytDetails.' + startOrEnd + 'LocationDetails.other', '' ).length > 0 ) {
                        // if the invite level has custom byt info for end location... display that
                        _.set( byt, startOrEnd + 'Location', byt.bytDetails[startOrEnd + 'LocationDetails'].other );
                    } else if ( startOrEndLocation === 'Other' ) {
                        // if the byt end or start is equal to 'Other', we need to show the actual value if it's there
                        // or show 'Other', if there is no further information

                        if ( _.get( startOrEndDetails, 'other', '' ).length > 0 ) {
                            // if there is more information than just "other", display that info
                            _.set( byt, startOrEnd + 'Location', startOrEndDetails.other );
                        } else {
                            // otherwise, just display 'Other' because we basic
                            _.set( byt, startOrEnd + 'Location', 'Other' );
                        }
                    } else {
                        // there is nothing special, so just show the regular stuff from the byt level
                        _.set( byt, startOrEnd + 'Location', startOrEndLocation );
                    }
                } );

                return byt;
            }
        }
    };
} );
